module.exports = __webpack_public_path__ + "img/pdf.5e683772.png";